import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment StatsWithFadingBackgroundImageData on StrapiComponentStatsWithFadingBackgroundImage {
    title
    topic
    description
    image {
      ...StrapiMediaSubquery
    }
    items {
      label
      value
      description
    }
  }
`;

function WithFadingBackgroundImage({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="relative bg-background-primary">
      <div className="absolute bottom-0 h-80 w-full xl:inset-0 xl:h-full">
        <div className="h-full w-full xl:grid xl:grid-cols-2">
          <div className="h-full overflow-hidden xl:relative xl:col-start-2">
            {data.image && (
              <MediaWrapper
                media={data.image}
                divClassName="h-full w-full opacity-25 xl:absolute xl:inset-0"
              />
            )}
            <div
              aria-hidden="true"
              className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-text-primary xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"
            />
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-flow-col-dense xl:grid-cols-2 xl:gap-x-8">
        <div className="relative pb-64 pt-12 sm:pb-64 sm:pt-24 xl:col-start-1 xl:pb-24">
          {data.subtitle && (
            <h3 className="text-sm font-semibold uppercase tracking-wide text-text-primary-light">
              <MarkdownWrapper text={data.subtitle} />
            </h3>
          )}
          {data.topic && (
            <h3 className="block text-base font-semibold uppercase tracking-wide text-text-white">
              <MarkdownWrapper text={data.topic} />
            </h3>
          )}
          {data.title && (
            <h2 className="mt-3 text-3xl font-extrabold text-text-white">
              <MarkdownWrapper text={data.title} />
            </h2>
          )}
          {data.description && (
            <MarkdownWrapper
              text={data.description}
              markdownClassName="mt-5 text-lg text-text-secondary-light"
              replaceParagraph={false}
            />
          )}
          {Boolean(data.items?.length) && (
            <div className="mt-12 grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2">
              {data.items.map((item) => (
                <div key={item.title}>
                  {item.value && (
                    <span className="block text-2xl font-bold text-text-white">
                      <MarkdownWrapper
                        text={item.value}
                        replaceParagraph={false}
                      />
                    </span>
                  )}
                  <span className="mt-1 block text-base text-text-secondary-light">
                    {item.label && (
                      <span className="font-medium text-text-white">
                        <MarkdownWrapper
                          text={item.label}
                          replaceParagraph={false}
                        />
                      </span>
                    )}
                    {item.description && (
                      <MarkdownWrapper
                        text={` ${item.description}`}
                        replaceParagraph={false}
                      />
                    )}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

WithFadingBackgroundImage.propTypes = {
  data: PropTypes.object,
};

export default WithFadingBackgroundImage;
